import { CheckCircleOutline, Close, RemoveRedEyeOutlined } from "@mui/icons-material";
import styled from "styled-components";

export const ReceiptContainer = styled.div`
  border: 1px solid var(--secondary-gray);
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  align-items: center;
  margin-top: 10px;

  &:hover {
    border: 1px solid var(--gray-light);
    background: var(--grey-grey-50); 
  }
`;

export const ReceiptLabel = styled.span`
  font-family: 'Nunito';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--luft-secondary-darker);

  ${({ disabled }) =>
    disabled &&
      `color: var(--light-opacity-gray);`}
`;

export const ReceiptStatus = styled.div`
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px; 
  color: var(--light-opacity-gray);
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ReceiptDate = styled.span`
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px; 
  color: var(--light-opacity-gray);
`;

export const ReceiptAction = styled.a`
  color: var(--luft-primary);
  font-size: 14px;
  line-height: 16px;
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  outline: none;
  text-decoration: none;
  padding: 4px 5px;
  font-weight: 500;
`;

export const ThumbContainer = styled.div`
  border: 1px solid var(--secondary-gray);
  box-sizing: border-box;
  border-radius: 4px;
  background-color: transparent;
  width: 72px;
  height: 72px;
`;

export const StyledImageSearchOutlined = styled(RemoveRedEyeOutlined)`
  margin-right: 4px;
  color: var(--luft-primary);
  height: 18px !important;
`;

export const FirstContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`;

export const SecondContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`;

export const SuccessCircleIcon = styled(CheckCircleOutline)`
  color: var(--luft-primary);
  height: 18px !important;
`;

export const StyledCloseIcon = styled(Close)`
  color: var(--luft-primary);
  height: 18px !important;
  margin-top: 1px;
`;

export const ReceiptsInfoActionContainer = styled.div`
  display: flex;
  align-items: center;
  border-radius: 6px;
  padding: 4px 5px;
  &:hover {
    background: var(--Light-Primary-Shades-4p); 
  }
`
